const map = {
  // CRM管理
  customerMarking: () => import('@/views/customerRelationship/CustomerMarking') // 打标
}

export default map
